import React from "react";
import { Github, Linkedin, Instagram, ArrowUp, Heart } from "lucide-react";

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <footer className="relative overflow-hidden border-t border-white/5 bg-[#050507] px-6 py-10 text-white sm:px-10 lg:px-20">
      {/* RGB glow */}
      <div className="pointer-events-none absolute left-1/4 top-0 h-40 w-40 rounded-full bg-cyan-500/[0.03] blur-[80px]" />

      <div className="pointer-events-none absolute right-1/4 bottom-0 h-40 w-40 rounded-full bg-purple-500/[0.03] blur-[80px]" />

      <div className="relative z-10 mx-auto max-w-7xl">
        <div className="flex flex-col items-center justify-between gap-8 md:flex-row">
          {/* Brand */}
          <div className="text-center md:text-left">
            <div className="flex items-center justify-center gap-3 md:justify-start">
              <div className="flex h-9 w-9 items-center justify-center rounded-xl border border-cyan-500/20 bg-gradient-to-br from-cyan-500/10 via-purple-500/10 to-pink-500/10">
                <span className="bg-gradient-to-r from-cyan-400 to-purple-400 bg-clip-text font-bold text-transparent">
                  A
                </span>
              </div>

              <div>
                <p className="text-sm font-bold">Arun Pungle</p>

                <p className="text-[10px] uppercase tracking-widest text-gray-600">
                  Java Backend Developer
                </p>
              </div>
            </div>

            <p className="mt-4 text-xs text-gray-600">
              Building scalable systems, one API at a time.
            </p>
          </div>

          {/* Social */}
          <div className="flex items-center gap-3">
            <a
              href="https://github.com/ArunPungle"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="GitHub"
              className="flex h-10 w-10 items-center justify-center rounded-xl border border-white/10 bg-white/[0.02] text-gray-500 transition hover:border-cyan-500/20 hover:text-cyan-300"
            >
              <Github size={17} />
            </a>

            <a
              href="https://www.linkedin.com/in/arun-pungle"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn"
              className="flex h-10 w-10 items-center justify-center rounded-xl border border-white/10 bg-white/[0.02] text-gray-500 transition hover:border-purple-500/20 hover:text-purple-300"
            >
              <Linkedin size={17} />
            </a>

            <a
              href="https://www.instagram.com/thenameisap_"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
              className="flex h-10 w-10 items-center justify-center rounded-xl border border-white/10 bg-white/[0.02] text-gray-500 transition hover:border-pink-500/20 hover:text-pink-300"
            >
              <Instagram size={17} />
            </a>

            <button
              onClick={scrollToTop}
              aria-label="Back to top"
              className="
                ml-2
                flex h-10 w-10
                items-center justify-center
                rounded-xl
                border border-purple-500/20
                bg-gradient-to-br from-cyan-500/10 via-purple-500/10 to-pink-500/10
                text-cyan-300
                transition
                hover:border-purple-400/40
                hover:shadow-[0_0_20px_rgba(168,85,247,0.15)]
              "
            >
              <ArrowUp size={17} />
            </button>
          </div>
        </div>

        <div className="mt-8 flex flex-col items-center justify-between gap-3 border-t border-white/5 pt-6 text-xs text-gray-600 sm:flex-row">
          <p>© {new Date().getFullYear()} Arun Pungle. All rights reserved.</p>

          <p className="flex items-center gap-1">
            Designed & built with
            <Heart size={12} className="fill-pink-500 text-pink-500" />
            using React
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
